import React from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'

import { ScrollArea } from 'react-wot-bootstrap'

import styles from './TextArea.scss'

export class TextArea extends React.Component {
    static propTypes = {
        width: PropTypes.number,
        height: PropTypes.number,
        maxHeight: PropTypes.number,
        value: PropTypes.string,
        placeholder: PropTypes.string,
        className: PropTypes.string,
        disabled: PropTypes.bool,
        onFocus: PropTypes.func,
        onBlur: PropTypes.func,
        onChange: PropTypes.func,
    }

    static defaultProps = {
        maxHeight: 200,
        disabled: false,
    }

    state = {
        isFocused: false,
        placeholder: this.props.placeholder || '',
        value: this.props.value || '',
        scrollOffset: 0,
    }

    setTextAreaRef = (element) => {
        this.textAreaRef = element
    }

    updateValue(value) {
        this.setState({ value })
    }

    moveCaretAtTheEnd(textArea) {
        const range = document.createRange()
        range.selectNodeContents(textArea)
        range.collapse(false)
        const selection = window.getSelection()
        selection.removeAllRanges()
        selection.addRange(range)
    }

    scrollAtTheEnd(textArea) {
        const height = textArea.offsetHeight
        this.setState({ scrollOffset: height })
    }

    focus = () => {
        if (this.textAreaRef) {
            this.textAreaRef.focus()
            this.moveCaretAtTheEnd(this.textAreaRef)
            this.scrollAtTheEnd(this.textAreaRef)
        }
    }

    blur = () => {
        this.textAreaRef && this.textAreaRef.blur()
    }

    handleFocus = (e) => {
        this.setState({ isFocused: true })

        if (this.props.onFocus) {
            this.props.onFocus(this.getEventWithValue(e))
        }
    }

    handleBlur = (e) => {
        this.setState({ isFocused: false })
        this.updateValue(e.target.innerText)

        if (this.props.onBlur) {
            this.props.onBlur(this.getEventWithValue(e))
        }
    }

    handleInput = (e) => {
        if (this.props.onChange) {
            this.props.onChange(this.getEventWithValue(e))
        }
    }

    getEventWithValue(e) {
        e.target.value = e.target.innerText
        return e
    }

    render() {
        const { disabled, maxHeight, width, height } = this.props
        const { isFocused, placeholder, value, scrollOffset } = this.state

        const scrollableAreaHeight = Math.max(maxHeight, height)

        const isPlaceholderVisible = !(isFocused || value)

        const baseClassNames = classNames(
            styles.base,
            isFocused && styles.base__focused,
            isPlaceholderVisible && styles.base__placeholder,
            disabled && styles.base__disabled,
            this.props.className,
        )

        return (
            <div
                className={baseClassNames}
                style={{ width: width }}
            >
                <div className={styles.wrapper}>
                    <ScrollArea
                        scrollableAreaHeight={scrollableAreaHeight}
                        scrollTopOffset={scrollOffset}
                    >
                        <div
                            ref={this.setTextAreaRef}
                            contentEditable={!disabled && 'plaintext-only'}
                            className={styles.textarea}
                            style={{ minHeight: height }}
                            onFocus={this.handleFocus}
                            onBlur={this.handleBlur}
                            onInput={this.handleInput}
                            suppressContentEditableWarning
                        >
                            {isPlaceholderVisible ? placeholder : value}
                        </div>
                    </ScrollArea>
                </div>
                {disabled && (
                    <div className={styles.disabledStateOverlay} />
                )}
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./containers/ClanLanding/components/TextArea/TextArea.jsx